import { ERecommendationsActionTypes } from '../../actions/recommendations';
import { TReduxActions } from '../../types/redux';
import { EPaginationStatus, IRecommendationsState } from '../../types/redux/recommendations';

export const recommendationsInitialState: IRecommendationsState = {
  recommendations: [],
  hasMore: false,
  page: 0,
  paginationStatus: EPaginationStatus.Idle,
  totalCount: null,
};

export function recommendationsReducer(state: IRecommendationsState, action: TReduxActions): IRecommendationsState {
  switch (action.type) {
    case ERecommendationsActionTypes.SetRecommendations:
      return {
        ...state,
        recommendations: action.payload,
      };
    case ERecommendationsActionTypes.AppendRecommendations:
      return {
        ...state,
        recommendations: [...state.recommendations, ...action.payload.recommendations],
        hasMore: action.payload.hasMore,
        page: action.payload.page,
        paginationStatus: EPaginationStatus.Idle,
        totalCount: action.payload.totalCount ?? state.totalCount,
      };
    case ERecommendationsActionTypes.SetRecommendationsPaginationStatus:
      return {
        ...state,
        paginationStatus: action.payload,
      };
    case ERecommendationsActionTypes.ToggleFavorite:
      return {
        ...state,
        recommendations: state.recommendations.map(recommendation =>
          recommendation.offerId === action.payload.offerId
            ? {
                ...recommendation,
                isFavorite: action.payload.isFavorite,
              }
            : recommendation,
        ),
      };
    default:
      return state || recommendationsInitialState;
  }
}
